import standardAPI from '@/api/standard_items';

const state = {
  contacts: [],
  contacts_status: '',
  contacts_MetaData: {},
  contacts_page: 1,
  contacts_perPage: 10,
};

const responseUrl = '/contacts';

const getters = {};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_contacts ({ commit }, getOptions) {
    commit('CONTACTS_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('CONTACTS_SUCCESS', response);
            commit('CONTACTS_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('CONTACTS_READY');
            reject(response);
          } else {
            commit('CONTACTS_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_contact ({ commit, dispatch }, itemData) {
    commit('CONTACTS_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          resolve(response);
        } else {
          commit('CONTACTS_READY');
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.contacts_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.contacts_perPage = max;
  },
  CONTACTS_READY: (state) => {
    state.contacts_status = 'ready';
  },
  CONTACTS_REQUEST: (state) => {
    state.contacts_status = 'loading';
  },
  CONTACTS_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.contacts_MetaData.meta = response.meta;
      state.contacts_MetaData.links = response.links;
    }
    state.contacts = response.data;
    state.contacts_status = 'success';
  },
  CONTACTS_ERROR: (state) => {
    state.contacts_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
